import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import { Widget, WidgetHeader, WidgetTitle, WidgetContent } from '../../../components/Widget';
import ContentLoading from '../../../components/ContentLoading';
import Button from '../../../components/Button';
import Icon from '../../../components/Icon';
import ContentError from '../../../components/ContentError';
import { SwitchCheckbox } from '../../../components/SwitchCheckbox';
import styles from './NotificationPreferencesEditor.m.sass';
var NotificationPreferencesEditor = observer(_class = /*#__PURE__*/function (_React$Component) {
  function NotificationPreferencesEditor() {
    _classCallCheck(this, NotificationPreferencesEditor);
    return _callSuper(this, NotificationPreferencesEditor, arguments);
  }
  _inherits(NotificationPreferencesEditor, _React$Component);
  return _createClass(NotificationPreferencesEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.store.activate();
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var store = this.props.store;
      var getMedium = function getMedium(key) {
        return store.typesMedia.find(function (x) {
          return x.key === key;
        });
      };
      var saving = store.save.pending;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles.contentPanel
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.headerRow
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.info
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.mediumTitle
      }, "Notification Types")), /*#__PURE__*/React.createElement("div", {
        className: cx(styles.mediumTitle, styles.label)
      }, "Push"), /*#__PURE__*/React.createElement("div", {
        className: cx(styles.mediumTitle, styles.label)
      }, "Email")), /*#__PURE__*/React.createElement("div", {
        className: styles.notificationCollection
      }, /*#__PURE__*/React.createElement(MediumEditor, {
        disabled: saving,
        medium: store.masterMedia,
        title: "All Notifications"
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.headerSpacer
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.notificationCollection
      }, /*#__PURE__*/React.createElement(MediumEditor, {
        disabled: saving,
        medium: getMedium('JobClosed'),
        title: "Job Closed",
        masterMedia: store.masterMedia
      }, "Receive notifications when a job has been closed."), /*#__PURE__*/React.createElement(MediumEditor, {
        disabled: saving,
        medium: getMedium('JobReopened'),
        title: "Job Reopened",
        masterMedia: store.masterMedia
      }, "Receive notifications when a job has been reopened."), /*#__PURE__*/React.createElement(MediumEditor, {
        disabled: saving,
        medium: getMedium('JobUpdated'),
        title: "Job Updated",
        masterMedia: store.masterMedia
      }, "Receive notifications when a job has been updated."), /*#__PURE__*/React.createElement(MediumEditor, {
        disabled: saving,
        medium: getMedium('MilestoneCompleted'),
        title: "Milestones Completed",
        masterMedia: store.masterMedia
      }, "Receive notifications when someone completes a milestone."), /*#__PURE__*/React.createElement(MediumEditor, {
        disabled: saving,
        medium: getMedium('NewJobAvailable'),
        title: "New Job Available",
        masterMedia: store.masterMedia
      }, "Receive notifications when a new job is available."), /*#__PURE__*/React.createElement(MediumEditor, {
        disabled: saving,
        medium: getMedium('NewMessage'),
        title: "New Message",
        masterMedia: store.masterMedia
      }, "Receive notifications when you receive a new message."), /*#__PURE__*/React.createElement(MediumEditor, {
        disabled: saving,
        medium: getMedium('UnreadMessage'),
        title: "Unread Message",
        masterMedia: store.masterMedia
      }, "Receive notifications if you have an unread message."), /*#__PURE__*/React.createElement(MediumEditor, {
        disabled: saving,
        medium: getMedium('UnreadDocument'),
        title: "Unread Document",
        masterMedia: store.masterMedia
      }, "Receive notifications if you have an unread document."))), /*#__PURE__*/React.createElement("div", {
        className: styles.notificationButtonContainer
      }, /*#__PURE__*/React.createElement(Button, {
        type: "primary",
        shadow: true,
        disabled: !store.hasChanges,
        className: styles.notificationButton,
        loading: saving,
        iconLeft: /*#__PURE__*/React.createElement(Icon, {
          material: true,
          name: "update"
        }),
        onClick: store.save.bind(store)
      }, "Update")));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var store = this.props.store;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(styles.root)
      }, /*#__PURE__*/React.createElement(Widget, {
        className: styles.widget
      }, /*#__PURE__*/React.createElement(WidgetHeader, {
        className: styles.widgetHeader
      }, /*#__PURE__*/React.createElement(WidgetTitle, {
        className: styles.widgetTitle
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.title
      }, "Preferences"), /*#__PURE__*/React.createElement("p", {
        className: styles.subtext
      }, "We send you notifications about your jobs. You can customize where you want to receive them here. It might be a few minutes for changes to take effect."))), /*#__PURE__*/React.createElement(WidgetContent, {
        className: styles.widgetContent,
        pad: true
      }, store.activate.match({
        pending: function pending() {
          return /*#__PURE__*/React.createElement(ContentLoading, {
            small: true
          });
        },
        rejected: function rejected(err) {
          return /*#__PURE__*/React.createElement(ContentError, {
            error: err
          });
        },
        resolved: function resolved() {
          return _this.renderContent();
        }
      }))));
    }
  }]);
}(React.Component)) || _class;
export { NotificationPreferencesEditor as default };
var MediumEditor = observer(function MediumEditor(_ref) {
  var title = _ref.title,
    children = _ref.children,
    medium = _ref.medium,
    disabled = _ref.disabled,
    masterMedia = _ref.masterMedia;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.notificationRow
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.icon
  }, /*#__PURE__*/React.createElement(Icon, {
    material: true,
    name: "notifications"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.mediumTitle
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles.mediumDescription
  }, children))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SwitchCheckbox, {
    disabled: masterMedia && masterMedia.pushEnabled === false ? true : disabled,
    className: styles.toggle,
    success: true,
    trueLabel: "On",
    falseLabel: "Off",
    value: medium.pushEnabled,
    onChange: medium.togglePush
  }), /*#__PURE__*/React.createElement(SwitchCheckbox, {
    disabled: masterMedia && masterMedia.emailEnabled === false ? true : disabled,
    className: styles.toggle,
    success: true,
    trueLabel: "On",
    falseLabel: "Off",
    value: medium.emailEnabled,
    onChange: medium.toggleEmail
  })));
});
//# sourceMappingURL=index.js.map
